import { useCallback, useEffect, useMemo } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { useAuthStore } from '../state/authStore';
import { Button } from '@cuspar/ui';
import { authAPI } from '../state/api/auth';
import { ROUTES } from '../routes';
import { useTranslation } from 'react-i18next';

export const AuthLayout: React.FC<{ authenticate?: boolean }> = ({ authenticate }) => {
  const tryAuthenticate = useAuthStore((state) => state.authenticate);
  const updateIsAuthenticating = useAuthStore((state) => state.updateIsAuthenticating);

  useEffect(() => {
    if (authenticate) authenticateUser();
  }, [authenticate]);

  async function authenticateUser() {
    updateIsAuthenticating(true);
    await tryAuthenticate();
    updateIsAuthenticating(false);
  }
  return (
    <div className='font-mono min-h-screen flex-1 flex flex-col items-center pt-4 md:pt-8 px-2'>
      <Outlet />
      <ImpersonationExitButton />
    </div>
  );
};

const ImpersonationExitButton = () => {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();
  const isImpersonating = useMemo(() => Boolean(user?.impersonatedByAdminId), [user]);
  const exit = useCallback(async () => {
    const res = await authAPI.exitImpersonation();
    if (res.success) {
      useAuthStore.getState().authenticate();
      navigate(ROUTES.admin.users);
    }
  }, []);
  if (!isImpersonating) return null;
  return (
    <div className='fixed bottom-4 right-4 z-50'>
      <Button variant='destructive' onClick={exit}>
        {t('auth.exitImpersonation')}
      </Button>
    </div>
  );
};
